module.exports = __webpack_public_path__ + "static/media/6.ee19fe35.jpg";